import type {
	AIFeedbackResponse,
	Choice,
	ItemFeedback,
	RenderableItemTypes,
} from "@memorang/types/src/session/new-session";
import AIExplanation from "../components/postanswer/AiExplanation";
import HumanExplanation from "../components/postanswer/HumanExplanation";
import { AI_SUBMITTABLE_VARIANTS } from "../constants";
import useAIFeedbackStore from "../hooks/useAIFeedbackStore";

type Props = {
	itemId: number;
	itemType: RenderableItemTypes;
	choices: Choice[];
	persistedAiFeedback?: AIFeedbackResponse;
	feedback?: ItemFeedback;
};
const ExplanationContainer = ({
	itemId,
	itemType,
	choices,
	persistedAiFeedback,
	feedback,
}: Props) => {
	const aiResponse = useAIFeedbackStore((state) => state.aiResponse);
	const streaming = useAIFeedbackStore((state) => state.streaming);

	const isAiItemType = AI_SUBMITTABLE_VARIANTS.includes(itemType);

	const currentItemAiResponse = aiResponse?.[itemId] || persistedAiFeedback;

	if (isAiItemType) {
		return (
			<AIExplanation
				aiResponse={
					currentItemAiResponse?.explanation || currentItemAiResponse?.feedback
				}
				loading={streaming}
				itemId={itemId}
			/>
		);
	}

	return (
		<HumanExplanation choices={choices} itemId={itemId} feedback={feedback} />
	);
};

export default ExplanationContainer;
